// extracted by mini-css-extract-plugin
export var becomePartner = "index-module--becomePartner--DpnB6";